<div class="betslip-taxation-info__row betslip-migration-info-header">
    <div class="betslip-taxation-info_text">{{ sitecoreMyBets.myBets.MigrationInfoHeader }}</div>
</div>
<div class="betslip-taxation-info__row betslip-migration-info-message">
    <div
        class="betslip-taxation-info_text betslip-stake-limits-link-text"
        [innerHtml]="sitecoreMyBets.myBets.MigrationInfoMessage | msTrust: 'html'"></div>
</div>
<div class="betslip-taxation-info_ok-text betslip-migration-info-ok-text" (click)="okClick()">{{ sitecoreMyBets.myBets.ConfirmMessage }}</div>
